import { Typography } from 'antd';
import Link from 'next/link';

const { Text } = Typography;

function VMCPricing() {
  return (
    <div className="position-relative z-index-1">
      <div className="w-layout-grid grid-2-columns title-and-buttons _1-col-tablet">
        <div className="inner-container _581px center---tablet">
          <div className="inner-container _400px---mbl">
            <div className="text-center---tablet">
              <div className="mg-bottom-24px">
                <div className="text-100 bold color-accent-1 text-uppercase">
                  Secure your brand&apos;s email presence now!
                </div>
              </div>
              <h2 className="display-2 color-neutral-100 mg-bottom-0">
                Brand Your Emails. <span className="text-no-wrap">Get More Opens.</span>
              </h2>
            </div>
          </div>
        </div>
        <div className="buttons-row center">
          <Link
            href="/products/digicert-verified-mark-certificate"
            className="btn-primary w-button"
          >
            Buy VMC Now<span className="line-rounded-icon link-icon-right"></span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default VMCPricing;
